/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Core Utilities
define('global/PackardAssets',[
    'jquery',
    'lodash',
    './Logger'
], function ($, _, Logger) {
    'use strict';

    var cfg = window.RocConfig;
    var packardAssetsDomain = cfg.packardAssets.packardAssetDomain;
    var imagesPath = cfg.packardAssets.imagesPath;

    var packardPrefixes = [
        {
            'prefix': cfg.packardAssets.imageSmallPrefix,
            'width': 80,
            'height': 80,
            'isDefault': false
        },
        {
            'prefix': cfg.packardAssets.imageMediumPrefix,
            'width': 200,
            'height': 200,
            'isDefault': true
        },
        {
            'prefix': cfg.packardAssets.imageLargePrefix,
            'width': 400,
            'height': 400,
            'isDefault': false
        },
        {
            'prefix': cfg.packardAssets.imageExtraLargePrefix,
            'width': 1500,
            'height': 1500,
            'isDefault': false
        }
    ];

    function matchImageSizeToPackardPrefix(width, height) {
        if (width !== undefined && height !== undefined) {
            for (var i = 0; i < packardPrefixes.length; i++) {
                if (width <= packardPrefixes[i].width && height <= packardPrefixes[i].height) {
                    return packardPrefixes[i].prefix;
                }
            }
        }

        var defaultPrefix = _.find(packardPrefixes, { 'isDefault': true });
        return defaultPrefix.prefix;
    }

    function getImageUrl(imageName, width, height) {
        /*
            Example of image name in Azure: 100001_sm_1.jpg
            Example of product images names in Catsy: 100001_1.jpg, 100001_2.jpg, etc. 
            (the number reflects the sort order of the images. _1 is the main image always)

            This function replaces '100001_1.jpg' -> 100001_DIMENSIONPREFIX_1.jpg 
            where DIMENSIONPREFIX is dimension prefix for the requested widht/height.
            In this case the resolved image name in Azure would be one of the following:
            100001_sm_1.jpg 
            100001_md_1.jpg 
            100001_lg_1.jpg 
            100001_xl_1.jpg
        */
        var match = imageName.match('_[^._]+(?=[^_]*$)');
        if (match === null) {
            throw "Invalid asset name";
        }
        var filename = imageName.substring(0, match.index);
        var prefix = matchImageSizeToPackardPrefix(width, height);
        var extension = imageName.substring(match.index + match["0"].length);

        return '//' + packardAssetsDomain + imagesPath + filename + prefix + match["0"] + extension;
    }
    
    
    var PackardAssets = {
        getImageUrl: getImageUrl
    };

    Logger.debug('PackardAssets.js Loaded:', PackardAssets);

    return PackardAssets;
});

